export default "__VITE_ASSET__Cw8dN5rq__"